import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface BaseActionDialogData {
    title: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    type?: "warning" | "info" | "error" | "success";
    showCancel?: boolean;
    callback: () => void;
}

@Component({
    selector: "app-base-action-dialog",
    templateUrl: "./base-action-dialog.component.html",
    styleUrls: ["./base-action-dialog.component.scss"],
})
export class BaseActionDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<BaseActionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: BaseActionDialogData
    ) {}

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        this.data.callback();
        this.dialogRef.close(true);
    }

    getIconClass(): string {
        switch (this.data.type) {
            case "warning":
                return "warning-icon";
            case "error":
                return "error-icon";
            case "success":
                return "success-icon";
            case "info":
            default:
                return "info-icon";
        }
    }

    getConfirmButtonClass(): string {
        switch (this.data.type) {
            case "warning":
                return "warning-button";
            case "error":
                return "error-button";
            case "success":
                return "success-button";
            case "info":
            default:
                return "info-button";
        }
    }
}
